"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Lightbulb = _interopRequireDefault(require("@honeybook/icons/dist/icons/Lightbulb24"));
var _Diamond = _interopRequireDefault(require("@honeybook/icons/dist/icons/Diamond16"));
var _mixins = require("../../styles/mixins");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBPopover = _interopRequireDefault(require("../HBPopover/HBPopover"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBTooltip = function HBTooltip(_ref) {
  var autoDismissMs = _ref.autoDismissMs,
    children = _ref.children,
    className = _ref.className,
    customStyle = _ref.customStyle,
    delayShowInMs = _ref.delayShowInMs,
    _ref$keepOpenOnHover = _ref.keepOpenOnHover,
    keepOpenOnHover = _ref$keepOpenOnHover === void 0 ? false : _ref$keepOpenOnHover,
    disabled = _ref.disabled,
    _ref$forceClose = _ref.forceClose,
    forceClose = _ref$forceClose === void 0 ? false : _ref$forceClose,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? '300px' : _ref$maxWidth,
    offsetX = _ref.offsetX,
    offsetY = _ref.offsetY,
    _ref$onOpenChange = _ref.onOpenChange,
    onOpenChange = _ref$onOpenChange === void 0 ? function () {} : _ref$onOpenChange,
    _ref$openTrigger = _ref.openTrigger,
    openTrigger = _ref$openTrigger === void 0 ? 'hover' : _ref$openTrigger,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    _ref$shouldSupportCli = _ref.shouldSupportClickOutside,
    shouldSupportClickOutside = _ref$shouldSupportCli === void 0 ? false : _ref$shouldSupportCli,
    _ref$isTargetContaine = _ref.isTargetContainerFocusable,
    isTargetContainerFocusable = _ref$isTargetContaine === void 0 ? false : _ref$isTargetContaine,
    target = _ref.target,
    targetContainerClassName = _ref.targetContainerClassName,
    targetContainerStyle = _ref.targetContainerStyle,
    _ref$tooltipTheme = _ref.tooltipTheme,
    tooltipTheme = _ref$tooltipTheme === void 0 ? 'darkTooltip' : _ref$tooltipTheme,
    _ref$openOnFocus = _ref.openOnFocus,
    openOnFocus = _ref$openOnFocus === void 0 ? true : _ref$openOnFocus,
    enableInitialOpen = _ref.enableInitialOpen;
  var isAdviceTooltip = tooltipTheme === 'adviceTooltip';
  var isUpgradeTooltip = tooltipTheme === 'upgradeTooltip';
  var timeoutRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isDoneShowing = _useState2[0],
    setIsDoneShowing = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!isDoneShowing && !forceClose && autoDismissMs) {
      timeoutRef.current = setTimeout(function () {
        setIsDoneShowing(true);
      }, autoDismissMs);
      return function () {
        clearTimeout(timeoutRef.current);
      };
    }
  }, [isDoneShowing, forceClose, autoDismissMs]);
  if (disabled) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, target);
  }
  return /*#__PURE__*/_react["default"].createElement(StyledPopover, {
    className: className,
    customStyle: customStyle,
    delayShowInMs: delayShowInMs,
    keepOpenOnHover: keepOpenOnHover,
    forceClose: forceClose || isDoneShowing,
    maxWidth: maxWidth,
    offsetX: offsetX,
    offsetY: offsetY,
    onOpenChange: onOpenChange,
    openTrigger: autoDismissMs ? null : openTrigger,
    placement: placement,
    shouldSupportClickOutside: shouldSupportClickOutside,
    isTargetContainerFocusable: isTargetContainerFocusable,
    shouldSupportOverflowHidden: true,
    target: target,
    targetContainerClassName: targetContainerClassName,
    targetContainerStyle: targetContainerStyle,
    theme: tooltipTheme,
    openOnFocus: openOnFocus,
    enableInitialOpen: enableInitialOpen,
    withArrow: true,
    testId: "HBTooltip",
    role: "tooltip"
  }, isAdviceTooltip && /*#__PURE__*/_react["default"].createElement(LightbulbIcon, {
    color: _colors["default"].white
  }), isUpgradeTooltip && /*#__PURE__*/_react["default"].createElement(DiamondIcon, {
    color: _colors["default"].alpine
  }), children);
};
var _default = exports["default"] = HBTooltip; // -------------------------------- Styles -------------------------------- //
var StyledPopover = (0, _styledComponents["default"])(_HBPopover["default"]).withConfig({
  displayName: "HBTooltip__StyledPopover",
  componentId: "sc-2p6jy1-0"
})(["", " white-space:pre-line;", ""], function (_ref2) {
  var maxWidth = _ref2.maxWidth;
  return "max-width: ".concat(maxWidth, ";");
}, _mixins.hideInPrint);
var LightbulbIcon = (0, _styledComponents["default"])(_Lightbulb["default"]).withConfig({
  displayName: "HBTooltip__LightbulbIcon",
  componentId: "sc-2p6jy1-1"
})(["position:absolute;left:12px;top:12px;"]);
var DiamondIcon = (0, _styledComponents["default"])(_Diamond["default"]).withConfig({
  displayName: "HBTooltip__DiamondIcon",
  componentId: "sc-2p6jy1-2"
})(["position:absolute;left:12px;top:12px;"]);
//# sourceMappingURL=HBTooltip.js.map